// extracted by mini-css-extract-plugin
export default {"MainContent":"Main_MainContent__uumKY","MainTop":"Main_MainTop__3rkKy","MainBottom":"Main_MainBottom__2L+S0"};